import { app } from '../../../app.module'
app.component('memoCardPost', {
  bindings: {
    memoCount: '=',
    postData: '=',
  },
  template: require('./memo-card-post.pug')(),
})
